import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppState {
  refreshDocuments: boolean;
  bsExchange: number;
}

const initialState: AppState = {
  refreshDocuments: false,
  bsExchange: 35.0,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppRefreshDocuments: (state, action: PayloadAction<boolean>) => {
      state.refreshDocuments = action.payload;
    },
    setAppBsExchange: (state, action: PayloadAction<number>) => {
      state.bsExchange = action.payload;
    },
  },
});

export const { setAppRefreshDocuments, setAppBsExchange } =
  appSlice.actions;

export default appSlice.reducer;
